import { useState } from 'react';
import { BudgetItemColors, BudgetItemLabels } from './constants';
import { BudgetExpenseId, BudgetValues } from './types';
import * as fields from './calculatedFields';

const useBudgetCalculator = () => {
  const [budgetValues, setBudgetValue] = useState<BudgetValues>({
    income: {
      monthlyIncome: 0,
    },
    expenses: {
      giving: 0,
      savings: 0,
      food: 0,
      utilities: 0,
      housing: 0,
      transportation: 0,
      insuranceAndTaxes: 0,
      householdItems: 0,
      debt: 0,
      retirement: 0,
      personalEntertainment: 0,
      other: 0,
    },
  });

  /* eslint-disable */
  const updateBudgetItem =
    (itemType: 'income' | 'expenses', itemKey: string) => (value: number) => {

      if (itemType === 'income' && itemKey === 'monthlyIncome') {
        // Only change these when monthlyIncome is updated
        const giving = fields.getGiving(value);
        const debt = fields.getDebt(value);
        const housing = fields.getHousing(value);
        const food = fields.getFood(value);
        const other = fields.getOther(value);
        const utilities = fields.getUtilities(value);
        const transportation = fields.getTransportation(value);
        const insuranceAndTaxes = fields.getInsuranceAndTaxes(value);
        const householdItems = fields.getHouseholdItems(value);
        const personalEntertainment = fields.getPersonalEntertainment(value);
        const incomeUpdatedEvent = new CustomEvent(
            "budgetCalculatorIncomeUpdated",
            { detail: { value } }
        );
        document.dispatchEvent(incomeUpdatedEvent);

        setBudgetValue({
          income: {
            monthlyIncome: value,
          },
          expenses: {
            ...budgetValues.expenses,
            giving,
            debt,
            housing,
            food,
            other,
            utilities,
            transportation,
            insuranceAndTaxes,
            householdItems,
            personalEntertainment,
          }
        })
      } else {

        setBudgetValue({
          ...budgetValues,
          [itemType]: {
            ...budgetValues[itemType],
            [itemKey]: value,
          },
        });
      }
    };
  /* eslint-enable */

  const getExpenses = () => {
    return Object.values(budgetValues.expenses).reduce((total, current) => {
      return total + current;
    }, 0);
  };

  const getDifference = () => {
    const { monthlyIncome } = budgetValues.income;
    const expenses = getExpenses();

    return monthlyIncome - expenses;
  };

  const getChartData = () => {
    return Object.entries(budgetValues.expenses).map(([key, value]) => ({
      name: BudgetItemLabels[key as BudgetExpenseId],
      value: value,
      fill: BudgetItemColors[key as BudgetExpenseId],
    }));
  };

  return {
    budgetValues,
    updateBudgetItem,
    getExpenses,
    getDifference,
    getChartData,
  };
};

export default useBudgetCalculator;
